<script>
import axios from 'axios';
import GfAnalyticsMixin from './GfAnalyticsMixin.vue';
import store from '../../store/store';

export default {
    name: 'CreateFundraisingPageMixin',
    mixins: [GfAnalyticsMixin],
    data: function() {
        return {
            store,
            pageType: '',
            teamId: 0,
            teamName: '',
            charityId: store.state.selected_charity.beneficiaryId,
            eventCampaignId: store.state.selected_event.EventCampaignId,
            createIndividualPageForTeam: store.state.details_team.createIndividualPage,
            referrer: store.state.referrer,
            pageCreationErrorMsg: '',
            activationId: store.state.activationId,
            pageId: store.state.pageId,
            disclaimerText: ''
        }
    },

    computed: {
      providerDetails() {
        return this.store.state.auth.provider
      },
      facebookAuth() {
        return this.store.state.auth.facebook
      },
      captchaPublicKey() {
        return this.store.state.captchaPublicKey
      }
    },

    mounted: function() {
        var vm = this;
        const emitter = this.$.appContext.config.globalProperties.emitter;
        if (emitter) {
            if (emitter.all.has("createFrp"))
                emitter.all.delete("createFrp")
            emitter.on('createFrp', function() {
                vm.pageCreationErrorMsg = '';
                vm.store.commit('creatingPage');
                vm.$_createFundraisingPageMixin_makeRequest();
            });
        }
    },

    methods: {
        async loadVueAnalytics(){
            try {
                await this.$_createFundraisingPageMixin_loadVueAnalytics();
            } catch (e) {
                console.log("Failed to load google Analytics.");
            }
        },
        $_createFundraisingPageMixin_loadDisclaimer: async function() {
            var self = this;
            var settingsRequest = {
                "SettingsContext": {
                    "EventId": this.eventCampaignId,
                    "Region": this.store.state.regionId,
                    "BeneficiaryId": this.charityId
                },
                "Types": [
                {
                    "ConfigurationName": "FundraisingPage",
                    "ConfigurationSubType":"Disclaimer"
                }
                ]
            };
            
            var result = await axios.post('/configuration/get-settings',
                settingsRequest,
                { headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
            });

            if (result.data) {
                const settingsData = result.data.Settings[0]?.Settings?.Settings;

                if (settingsData) {
                    const parsedSettings = JSON.parse(settingsData);
                    const pageCreationSettings = parsedSettings?.settings.filter(setting => setting.type === "PageCreation");

                    if (pageCreationSettings && pageCreationSettings.length > 0) {
                        this.disclaimerText = pageCreationSettings[0].disclaimerText;
                    }
                }
                const replacements = { charityName: this.store.state.selected_charity.BeneficiaryName };

                this.disclaimerText = this.disclaimerText.replace(/{(\w+)}/g, (match, key) => {
                    return replacements[key] || match;
                });
                self.store.commit("setDisclaimerText", this.disclaimerText);
            }
        },
        $_createFundraisingPageMixin_loadVueAnalytics: async function() {
            var settingsRequest = {
                "SettingsContext": {
                "EventId": this.eventCampaignId,
                "Region": this.store.state.regionId
                },
                "Types": [
                {
                    "ConfigurationName": "EventCampaign",
                    "ConfigurationSubType":"Analytics"
                }
                ]
            };
            
            var result = await axios.post('/configuration/get-settings',
                settingsRequest,
                { headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
            });

            if (result.data) {
                var settings = JSON.parse(result.data.Settings[0].Settings.Settings);
                var googleAnalytics = settings.filter(x => x.type == "Google");
                var googleAnalyticsIds = googleAnalytics.map(x=> x.settings.id);                
                this.initialize(googleAnalyticsIds);                
            }
        },

        $_createFundraisingPageMixin_makeRequest: function() {
            var self = this;
            var fundraiser_type = self.store.state.isRegister == true ? "new" :"existing";            
            if(self.store.state.pageType === "joinTeam"){
                    self.analytics({ 
                        event : 'create_page',
                        createType: self.store.state.createType,
                        stepNumber: "3 of 3",
                        stepName: "fundraiser details",                        
                        fundraiserType: fundraiser_type
                    });
                }else{
                    self.analytics({ 
                        event : 'create_page',
                        createType: self.store.state.createType,
                        stepNumber: "4 of 4",
                        stepName: "complete",
                        causeName: self.store.state.selected_charity.BeneficiaryName,
                        eventName: self.store.state.selected_event.EventName,
                        fundraiserType: fundraiser_type
                    });
                }
            var pageId = parseInt(this.pageId);
            if (pageId === NaN)
                pageId = null;
                
            axios.post('/pages/create-fundraising-page', {
            data: JSON.stringify({ 
                PageModel: {
                    CharityId: this.charityId,
                    ActivationId: this.activationId,
                    PageId: pageId,
                    EventCampaignId: this.eventCampaignId,
                    PageType: this.pageType,
                    TeamId: this.teamId,
                    TeamName: this.pageType === "T" ? this.store.state.details_team.teamName : "",
                    CreateIndividualPageForTeam: this.store.state.details_team.createIndividualPage,
                    IsCreatingNewUser: this.store.state.isCreatingNewUser,
                    TeamTarget: this.store.state.details_team.teamTarget === "" || this.pageType === "S" ? "0" : this.store.state.details_team.teamTarget,
                    Referrer: this.referrer
                }})
            }, 
            { 
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }
            ).then(function(res) {                           
                if (!res.data.success) {
                    self.onPageCreationError(res.data.text);
                    return;
                }

                if (window.opener) {
                    self.sendPostMessageToOpener(res.data.data);
                }
                
                var pageCount = 1;
                if (self.pageType === "T" && self.store.state.details_team.createIndividualPage)
                    pageCount = 2;
                
                                  
                if(self.store.state.pageType === "createTeam"){
                    self.analytics({ 
                        event : 'page_creation',
                        createType: self.store.state.createType,                    
                        causeName: res.data.data.charityName,
                        eventName: res.data.data.eventName,
                        teamId: res.data.data.pageId,                                           
                    });
                }else{
                    self.analytics({ 
                        event : 'page_creation',
                        createType: self.store.state.createType,                    
                        causeName: res.data.data.charityName,
                        eventName: res.data.data.eventName,                        
                        pageId: res.data.data.pageId                    
                    });
                }

                window.location = res.data.data.pageUrl;
            }).catch(function(error) {
                self.onPageCreationError("An unknown error occurred creating the fundraising page. Please contact support.");                                
            });
        },

        $_createFundraisingPageMixin_onLoggedIn(userEmail, isCreatingNewUser) {
            this.$gfLogger.logInfo('_createFundraisingPageMixin_onLoggedIn, userEmail:', userEmail)
            this.$gfLogger.logInfo('_createFundraisingPageMixin_onLoggedIn, isCreatingNewUser:', isCreatingNewUser)
          this.store.commit("preUserLogin", userEmail)
          this.store.commit("setIsCreatingNewUser", isCreatingNewUser)
          this.$.appContext.config.globalProperties.emitter.emit('createFrp')
        },

        onPageCreationError: function (err) {
            this.$.appContext.config.globalProperties.emitter.emit('pageCreationFailed', err);
            this.store.commit('resetCreatingPageState');
            this.pageCreationErrorMsg = err;
        },

        sendPostMessageToOpener: function(data) {            
            var extIds = data.charityExternalIds;
            var extIdList = [];

            for (var a = 0; a < extIds.length; a++) {
                var o = new Object();
                o.Id = extIds[a].ExternalId;
                o.Type = extIds[a].Type;
                extIdList.push(o);
            };

            var postData = {
                "Application": "GoFundraise",
                "Type": "Page",
                "Action": "Create",
                "Data": {
                    "Page": {
                        "PageId": data.pageId,
                        "PageImagePath": data.pageImagePath,
                        "PageTitle": data.pageTitle,
                        "PageCreatorName": data.pageCreatorName,
                        "PageUrl": data.pageUrl,
                        "PageRaiseTarget": data.pageTarget,
                        "PageTotal": data.pageRaised,
                        "PageDonationUrl": data.pageDonationUrl
                    },
                    "Beneficiary": {
                        "BeneficiaryAccountId": data.charityId,
                        "BeneficiaryImagePath": data.charityImagePath,
                        "BeneficiaryName": data.charityName,
                        "BeneficiaryUrl": data.charityUrl,
                        "BeneficiaryExternalIds": extIdList
                    },
                    "Event": {
                        "EventCampaignId": data.eventCampaignId,
                        "EventImagePath": data.eventImagePath,
                        "EventName": data.eventName,
                        "EventUrl": data.eventUrl
                    }
                }
            }
            window.opener.postMessage(JSON.stringify(postData), '*');
        }
    }
}
</script>
